export const heatingMask = 0x0020;
export const fanMask = 0x2000;

export const displayOnCoolingMask = 0x1000;
export const displayOffCoolingMask = 0x10000 + displayOnCoolingMask;
export const celciusMask = 0x200;
export const fahrenheitMask = 0x10000 + celciusMask;
export const vibrationOnMask = 0x400;
export const vibrationOffMask = 0x10000 + vibrationOnMask;
